import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, SET_TELEPHONY_USER } from './types';
import selectOptionsCreator from '../../../utils/selectOptionsCreator';
import { OUTSIDE_API } from '../../../consts/endpoints';
import { isArray, isDefined } from '../../../utils/isDefined';
import { mitelRequest } from '../../../utils/mitelRequest';
import mapTelephonyDataForForm from './mapTelephonyDataForForm';
import { prepareTelephonySelectsOptions } from './prepareSelectsOptions';
import { getData } from '../../../utils/http';
import mapLicenses from './mapLicenses';
import orderBy from 'lodash.orderby';

export function setTelephonyUser({
  userId,
  clientConnectId,
  isTelephonyUser,
  fromUsersTable,
  fromGroupsTable,
  roles,
  id
}) {
  return {
    type: sagaActions[SET_TELEPHONY_USER],
    userId,
    clientConnectId,
    isTelephonyUser,
    fromUsersTable,
    fromGroupsTable,
    roles,
    id
  };
}

export function* getTelephonyUser({
  userId,
  clientConnectId,
  isTelephonyUser,
  fromUsersTable,
  fromGroupsTable,
  roles,
  id
}) {
  const SELECTS_ARRAY_PARAMS = [
    {
      customEndpoint: `${OUTSIDE_API.CLIENTS}/${clientConnectId}/languages`,
      queryParams: {},
      ignoreNoneOption: true,
      customKey: 'DOMAIN_LANGUAGES'
    },
    {
      endpoint: 'ROLES',
      queryParams: { fields: { partners: 'name' } },
      ignoreNoneOption: true
    }
  ];

  const selectsOptions = yield call(selectOptionsCreator, SELECTS_ARRAY_PARAMS);

  const { data: userData } = yield call(mitelRequest, {
    options: {
      url: `${OUTSIDE_API.CLIENTS}/${clientConnectId}/users/${userId}`
    }
  });

  const { data: clientRanges } = yield call(mitelRequest, {
    options: {
      url: `${OUTSIDE_API.CLIENTS}/${clientConnectId}/number_ranges?include_usage=true`
    }
  });

  const availableNumbers = yield call(mapClientRanges, clientRanges);

  const {
    mappedselectOptions,
    languageId
  } = yield call(prepareTelephonySelectsOptions, { selectsOptions, userData });

  const { data: groups } = yield call(mitelRequest, {
    options: {
      url: `${OUTSIDE_API.CLIENTS}/${clientConnectId}/user_groups`
    }
  });

  const licenses = yield call(
    getData,
    `${OUTSIDE_API.CLIENTS}/${clientConnectId}/licenses`
  );
  const mappedLicenses = yield call(mapLicenses, licenses);

  const mappedData = yield call(mapTelephonyDataForForm, {
    userData,
    groups,
    languageId
  });

  yield put(reduxActions.setSelectsOptions(mappedselectOptions));
  yield put(
    reduxActions.setUser({
      mitelUserId: userId,
      user: { ...mappedData, roles, id },
      isDomainProvided: isDefined(clientConnectId),
      clientConnectId,
      isTelephonyUser,
      fromUsersTable,
      fromGroupsTable,
      licenses: mappedLicenses,
      availableNumbers
    })
  );
}

function* watchSetTelephonyUser() {
  yield takeLatest(sagaActions[SET_TELEPHONY_USER], getTelephonyUser);
}

export default watchSetTelephonyUser();

const mapClientRanges = clientRanges => {
  const mapped = clientRanges.reduce((arr, range) => {
    const { unassigned_numbers } = range;

    if (!isArray(unassigned_numbers) || unassigned_numbers.length === 0) {
      return arr;
    }

    return [
      ...arr,
      ...unassigned_numbers.map(number => ({
        value: number,
        label: number
      }))
    ];
  }, []);

  return orderBy(mapped, ['label'], ['asc']);
};
